import { Controller } from "@hotwired/stimulus"

// A notice that fades away after a few seconds (alerts stay until dismissed)
export default class extends Controller {
  static values = { timeout: { type: Number, default: 6000 } }

  connect() {
    if (this.element.getAttribute("role") === "status") {
      this.timer = setTimeout(() => this.dismiss(), this.timeoutValue)
    }
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  dismiss() {
    this.element.style.transition = "opacity 200ms ease-out"
    this.element.style.opacity = "0"
    setTimeout(() => this.element.remove(), 200)
  }
}
